import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { useEffect, useState } from "react";
import {
  DATAMODEL_CREATION,
  EMPTY_ARRAY,
  MODAL_SIZE,
  ONE,
  ZERO,
} from "../../../../constants";
import Modal, { setSelectedModal } from "../../Modal";
import { errorIcon } from "../../../../assets/icons";
import { selectAlert } from "../../Alert";
import { selectAreResourcesPending } from "../../../../pages/DataModels";

const { MD } = MODAL_SIZE;
const TIME_INTERVAL = 20000;

const Footer = ({ handleClick }) => (
  <div className="p-6 border-t border-gray-700 flex align-center justify-end">
    <button
      type="button"
      className="btn btn-primary-light mr-1"
      onClick={() => handleClick()}
    >
      Close
    </button>
  </div>
);

const TemplateCreationModal = () => {
  const dispatch = useDispatch();

  const selectedError = useSelector(selectAlert);
  const areResourcesPending = useSelector(
    selectAreResourcesPending
  );

  const [error, setError] = useState(false);
  const [messages, setMessages] = useState(EMPTY_ARRAY);
  const [currentIndex, setCurrentIndex] = useState(ZERO);

  useEffect(() => {
    selectedError && setError(selectedError.message || selectedError);
  }, [selectedError]);

  useEffect(() => {
    setMessages(DATAMODEL_CREATION);
  },[]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (currentIndex < messages.length - ONE)
        setCurrentIndex(currentIndex + ONE);
    }, TIME_INTERVAL);

    return () => {
      clearInterval(timer);
    };
  }, [currentIndex, messages]);

  useEffect(() => {
    if (!areResourcesPending) dispatch(setSelectedModal());
  }, [areResourcesPending, dispatch]);

  const footer = !isEmpty(error) ? (
    <Footer handleClick={() => dispatch(setSelectedModal())} />
  ) : null;

  return (
    <Modal
      title="Generating Resources for your Database"
      size={MD}
      footer={footer}
      shouldShowAlertMessage={false}
    >
      <div className="h-30 flex-col justify-center mt-6 mb-6">
        <div>
          <div className="flex justify-center">
            <img
              src={
                error?.customErrorMessage || error
                  ? errorIcon
                  : messages[currentIndex]?.image
              }
              className={classNames("w-12 h-12 justify-center", {
                "animate-bounce": isEmpty(error),
              })}
              alt="process-icon"
            />
          </div>

          <div
            className={classNames(
              "text-lg justify-center text-center font-bold",
              { "!text-red-600 mt-2": !isEmpty(error) },
              { "text-white animate-pulse": isEmpty(error) }
            )}
          >
            {!isEmpty(error)
              ? `Error : ${error?.customErrorMessage || error}`
              : messages[currentIndex]?.message}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TemplateCreationModal;
